__turbopack_context__.v({
  "actions": "Disclaimer-module-scss-module__Yu8Bgq__actions",
  "close": "Disclaimer-module-scss-module__Yu8Bgq__close",
  "closeButton": "Disclaimer-module-scss-module__Yu8Bgq__closeButton",
  "disclaimer": "Disclaimer-module-scss-module__Yu8Bgq__disclaimer",
  "header": "Disclaimer-module-scss-module__Yu8Bgq__header",
  "headerIcon": "Disclaimer-module-scss-module__Yu8Bgq__headerIcon",
  "headerText": "Disclaimer-module-scss-module__Yu8Bgq__headerText",
  "headerTitle": "Disclaimer-module-scss-module__Yu8Bgq__headerTitle",
  "modal": "Disclaimer-module-scss-module__Yu8Bgq__modal",
  "overlay": "Disclaimer-module-scss-module__Yu8Bgq__overlay",
  "text": "Disclaimer-module-scss-module__Yu8Bgq__text",
  "trigger": "Disclaimer-module-scss-module__Yu8Bgq__trigger",
  "triggerIcon": "Disclaimer-module-scss-module__Yu8Bgq__triggerIcon",
});
